import * as angular from "angular";
import {IController} from "angular";

export class AgentMenuSelectCtrl implements IController {
  agents: any;
  selectedAgent: any;
  onSelectAgent: Function;
}

angular
  .module('bringoz.admin.accounts')
  .component('agentMenuSelect', {
    bindings: {
      agents: '<',
      selectedAgent: '<',
      onSelectAgent: '&'
    },
    template: require('./agent-menu-select.html').default,
    controller: AgentMenuSelectCtrl
  });
